import { RoutePath } from 'enums/Routes';
import FinancialDashboard from 'components/FinancialCheckup/FinancialDashboard';
import ManageYourLoan from 'components/FinancialCheckup/FinancialDashboard/Loan/ManageYourLoan';
import TransactionDetail from 'components/FinancialCheckup/TransactionDetail/TransactionDetail';
import LoanPaymentDetail from 'components/FinancialCheckup/LoanPaymentDetail/LoanPaymentDetail';
import YourLoans from 'components/FinancialCheckup/FinancialDashboard/Loan/YourLoans';
import LoanHistoryPage from 'components/FinancialCheckup/FinancialDashboard/Loan/LoansHistoryPage';

import { NextFunction, RouterType } from './types';
import { getShiftsRoutes } from './ShiftsRoutes';

export const getFinancialCheckupRoutes = (): RouterType => ({
  [RoutePath.FinancialDashboard]: {
    component: FinancialDashboard,
    handleNext: () => () => {},
  },
  [RoutePath.YourLoans]: {
    navigationInfo: { showBackLink: true, title: 'Your loans' },
    component: YourLoans,
  },
  [RoutePath.ManageYourLoan]: {
    navigationInfo: { showBackLink: true, title: 'Your loan' },
    component: ManageYourLoan,
  },
  [RoutePath.LoansHistory]: {
    navigationInfo: { showBackLink: true, title: 'Loan history' },
    component: LoanHistoryPage,
  },
  [RoutePath.MethodPayment]: {
    navigationInfo: { showBackLink: true, title: 'Transaction details' },
    component: TransactionDetail,
  },
  ...getShiftsRoutes(),
  [RoutePath.LoanPayment]: {
    navigationInfo: { showBackLink: true, title: 'Payment details' },
    component: LoanPaymentDetail,
  },
});

export const backToFinancialDashboard: NextFunction = ({ navigate }) => () => {
  navigate(RoutePath.FinancialDashboard);
};
